import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-NoVideo",
  "use": "svg-icon-NoVideo-usage",
  "viewBox": "0 0 55 54",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 55 54\" id=\"svg-icon-NoVideo\"><g fill=\"none\" fill-rule=\"evenodd\"><path stroke=\"#000\" stroke-opacity=\".3\" stroke-width=\"5\" d=\"M9.5 13.5h36v27h-36z\" /><path fill=\"#000\" fill-opacity=\".3\" d=\"M23 21.892c0-.328.187-.629.485-.784a.955.955 0 0 1 .944.035l8.15 5.11a.884.884 0 0 1 .421.748c0 .302-.16.583-.42.747l-8.15 5.111a.967.967 0 0 1-.945.034.885.885 0 0 1-.485-.785V21.892z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol